
import _Icons16X16ColorfulLogo5Post from '@sima-land/ui-quarks/icons/16x16/Colorful/Logo5Post';
import _Icons16X16ColorfulLogoAptekaPlus from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoAptekaPlus';
import _Icons16X16ColorfulLogoAvitoSima from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoAvitoSima';
import _Icons16X16ColorfulLogoBoxberry from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoBoxberry';
import _Icons16X16ColorfulLogoDalli from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoDalli';
import _Icons16X16ColorfulLogoDellin from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoDellin';
import _Icons16X16ColorfulLogoDpd from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoDpd';
import _Icons16X16ColorfulLogoGalamart from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoGalamart';
import _Icons16X16ColorfulLogoOzon from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoOzon';
import _Icons16X16ColorfulLogoOzonSima from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoOzonSima';
import _Icons16X16ColorfulLogoPickPoint from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoPickPoint';
import _Icons16X16ColorfulLogoPost from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoPost';
import _Icons16X16ColorfulLogoSberLogistic from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoSberLogistic';
import _Icons16X16ColorfulLogoSdek from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoSdek';
import _Icons16X16ColorfulLogoSima from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoSima';
import _Icons16X16ColorfulLogoWildberriesSima from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoWildberriesSima';
import _Icons16X16ColorfulLogoYandex from '@sima-land/ui-quarks/icons/16x16/Colorful/LogoYandex';
import _Icons16X16FilledCamera from '@sima-land/ui-quarks/icons/16x16/Filled/Camera';
import _Icons16X16FilledCircleAdd from '@sima-land/ui-quarks/icons/16x16/Filled/CircleAdd';
import _Icons16X16FilledCircleCheck from '@sima-land/ui-quarks/icons/16x16/Filled/CircleCheck';
import _Icons16X16FilledCircleCross from '@sima-land/ui-quarks/icons/16x16/Filled/CircleCross';
import _Icons16X16FilledDolphin from '@sima-land/ui-quarks/icons/16x16/Filled/Dolphin';
import _Icons16X16FilledEye from '@sima-land/ui-quarks/icons/16x16/Filled/Eye';
import _Icons16X16FilledFunnel from '@sima-land/ui-quarks/icons/16x16/Filled/Funnel';
import _Icons16X16FilledGeoArrow from '@sima-land/ui-quarks/icons/16x16/Filled/GeoArrow';
import _Icons16X16FilledHeart from '@sima-land/ui-quarks/icons/16x16/Filled/Heart';
import _Icons16X16FilledPerson from '@sima-land/ui-quarks/icons/16x16/Filled/Person';
import _Icons16X16FilledPlace from '@sima-land/ui-quarks/icons/16x16/Filled/Place';
import _Icons16X16FilledShare from '@sima-land/ui-quarks/icons/16x16/Filled/Share';
import _Icons16X16FilledSortDown from '@sima-land/ui-quarks/icons/16x16/Filled/SortDown';
import _Icons16X16FilledSortUp from '@sima-land/ui-quarks/icons/16x16/Filled/SortUp';
import _Icons16X16FilledSpeechBubble from '@sima-land/ui-quarks/icons/16x16/Filled/SpeechBubble';
import _Icons16X16FilledStar from '@sima-land/ui-quarks/icons/16x16/Filled/Star';
import _Icons16X16FilledThumbDown from '@sima-land/ui-quarks/icons/16x16/Filled/ThumbDown';
import _Icons16X16FilledThumbUp from '@sima-land/ui-quarks/icons/16x16/Filled/ThumbUp';
import _Icons16X16FilledTooltip from '@sima-land/ui-quarks/icons/16x16/Filled/Tooltip';
import _Icons16X16FilledTrash from '@sima-land/ui-quarks/icons/16x16/Filled/Trash';
import _Icons16X16FilledWallet from '@sima-land/ui-quarks/icons/16x16/Filled/Wallet';
import _Icons16X16StrokedAdd from '@sima-land/ui-quarks/icons/16x16/Stroked/Add';
import _Icons16X16StrokedArrowDown from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowDown';
import _Icons16X16StrokedArrowDownSquare from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowDownSquare';
import _Icons16X16StrokedArrowExpandDown from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowExpandDown';
import _Icons16X16StrokedArrowExpandLeft from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowExpandLeft';
import _Icons16X16StrokedArrowExpandRight from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowExpandRight';
import _Icons16X16StrokedArrowExpandUp from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowExpandUp';
import _Icons16X16StrokedArrowLeft from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowLeft';
import _Icons16X16StrokedArrowRight from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowRight';
import _Icons16X16StrokedArrowTurnLeft from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowTurnLeft';
import _Icons16X16StrokedArrowTurnRight from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowTurnRight';
import _Icons16X16StrokedArrowUp from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowUp';
import _Icons16X16StrokedArrowUpAndDown from '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowUpAndDown';
import _Icons16X16StrokedBurger from '@sima-land/ui-quarks/icons/16x16/Stroked/Burger';
import _Icons16X16StrokedCart from '@sima-land/ui-quarks/icons/16x16/Stroked/Cart';
import _Icons16X16StrokedCheck from '@sima-land/ui-quarks/icons/16x16/Stroked/Check';
import _Icons16X16StrokedCopy from '@sima-land/ui-quarks/icons/16x16/Stroked/Copy';
import _Icons16X16StrokedCross from '@sima-land/ui-quarks/icons/16x16/Stroked/Cross';
import _Icons16X16StrokedExpandArrows from '@sima-land/ui-quarks/icons/16x16/Stroked/ExpandArrows';
import _Icons16X16StrokedInformation from '@sima-land/ui-quarks/icons/16x16/Stroked/Information';
import _Icons16X16StrokedLock from '@sima-land/ui-quarks/icons/16x16/Stroked/Lock';
import _Icons16X16StrokedMinus from '@sima-land/ui-quarks/icons/16x16/Stroked/Minus';
import _Icons16X16StrokedPlaceholder from '@sima-land/ui-quarks/icons/16x16/Stroked/Placeholder';
import _Icons16X16StrokedPlus from '@sima-land/ui-quarks/icons/16x16/Stroked/Plus';
import _Icons16X16StrokedRemove from '@sima-land/ui-quarks/icons/16x16/Stroked/Remove';
import _Icons16X16StrokedScreamer from '@sima-land/ui-quarks/icons/16x16/Stroked/Screamer';
import _Icons16X16StrokedVariation from '@sima-land/ui-quarks/icons/16x16/Stroked/Variation';
import _Icons16X16StrokedWatch from '@sima-land/ui-quarks/icons/16x16/Stroked/Watch';
import _Icons24X24ColorfulLink from '@sima-land/ui-quarks/icons/24x24/Colorful/Link';
import _Icons24X24ColorfulLinkCheck from '@sima-land/ui-quarks/icons/24x24/Colorful/LinkCheck';
import _Icons24X24ColorfulLogoDolyame from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoDolyame';
import _Icons24X24ColorfulLogoFacebook from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoFacebook';
import _Icons24X24ColorfulLogoJcb from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoJcb';
import _Icons24X24ColorfulLogoMaestro from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoMaestro';
import _Icons24X24ColorfulLogoMastercard from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoMastercard';
import _Icons24X24ColorfulLogoMir from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoMir';
import _Icons24X24ColorfulLogoOk from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoOk';
import _Icons24X24ColorfulLogoPlatiChastyami from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoPlatiChastyami';
import _Icons24X24ColorfulLogoPodeli from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoPodeli';
import _Icons24X24ColorfulLogoSber from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoSber';
import _Icons24X24ColorfulLogoSberCredit from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoSberCredit';
import _Icons24X24ColorfulLogoSbp from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoSbp';
import _Icons24X24ColorfulLogoTelegram from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoTelegram';
import _Icons24X24ColorfulLogoTwitter from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoTwitter';
import _Icons24X24ColorfulLogoUnionPay from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoUnionPay';
import _Icons24X24ColorfulLogoViber from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoViber';
import _Icons24X24ColorfulLogoVisa from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVisa';
import _Icons24X24ColorfulLogoVisaDarkMode from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVisaDarkMode';
import _Icons24X24ColorfulLogoVk from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVk';
import _Icons24X24ColorfulLogoVsegdaDa from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVsegdaDa';
import _Icons24X24ColorfulLogoVsegdaDaDarkMode from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVsegdaDaDarkMode';
import _Icons24X24ColorfulLogoWhatsApp from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoWhatsApp';
import _Icons24X24ColorfulLogoYandexPlus from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoYandexPlus';
import _Icons24X24ColorfulLogoYandexSplit from '@sima-land/ui-quarks/icons/24x24/Colorful/LogoYandexSplit';
import _Icons24X24FilledBall from '@sima-land/ui-quarks/icons/24x24/Filled/Ball';
import _Icons24X24FilledBlazon from '@sima-land/ui-quarks/icons/24x24/Filled/Blazon';
import _Icons24X24FilledBusiness from '@sima-land/ui-quarks/icons/24x24/Filled/Business';
import _Icons24X24FilledCard from '@sima-land/ui-quarks/icons/24x24/Filled/Card';
import _Icons24X24FilledCircleCheck from '@sima-land/ui-quarks/icons/24x24/Filled/CircleCheck';
import _Icons24X24FilledCircleCross from '@sima-land/ui-quarks/icons/24x24/Filled/CircleCross';
import _Icons24X24FilledCrown from '@sima-land/ui-quarks/icons/24x24/Filled/Crown';
import _Icons24X24FilledEgg from '@sima-land/ui-quarks/icons/24x24/Filled/Egg';
import _Icons24X24FilledFavorite from '@sima-land/ui-quarks/icons/24x24/Filled/Favorite';
import _Icons24X24FilledFlash from '@sima-land/ui-quarks/icons/24x24/Filled/Flash';
import _Icons24X24FilledFlower from '@sima-land/ui-quarks/icons/24x24/Filled/Flower';
import _Icons24X24FilledHalloween from '@sima-land/ui-quarks/icons/24x24/Filled/Halloween';
import _Icons24X24FilledHat from '@sima-land/ui-quarks/icons/24x24/Filled/Hat';
import _Icons24X24FilledHeart from '@sima-land/ui-quarks/icons/24x24/Filled/Heart';
import _Icons24X24FilledLogoDzen from '@sima-land/ui-quarks/icons/24x24/Filled/LogoDzen';
import _Icons24X24FilledLogoFacebook from '@sima-land/ui-quarks/icons/24x24/Filled/LogoFacebook';
import _Icons24X24FilledLogoGoogle from '@sima-land/ui-quarks/icons/24x24/Filled/LogoGoogle';
import _Icons24X24FilledLogoInspiration from '@sima-land/ui-quarks/icons/24x24/Filled/LogoInspiration';
import _Icons24X24FilledLogoInstagram from '@sima-land/ui-quarks/icons/24x24/Filled/LogoInstagram';
import _Icons24X24FilledLogoMail from '@sima-land/ui-quarks/icons/24x24/Filled/LogoMail';
import _Icons24X24FilledLogoOk from '@sima-land/ui-quarks/icons/24x24/Filled/LogoOk';
import _Icons24X24FilledLogoSkype from '@sima-land/ui-quarks/icons/24x24/Filled/LogoSkype';
import _Icons24X24FilledLogoTelegram from '@sima-land/ui-quarks/icons/24x24/Filled/LogoTelegram';
import _Icons24X24FilledLogoTikTok from '@sima-land/ui-quarks/icons/24x24/Filled/LogoTikTok';
import _Icons24X24FilledLogoTwitter from '@sima-land/ui-quarks/icons/24x24/Filled/LogoTwitter';
import _Icons24X24FilledLogoViber from '@sima-land/ui-quarks/icons/24x24/Filled/LogoViber';
import _Icons24X24FilledLogoVk from '@sima-land/ui-quarks/icons/24x24/Filled/LogoVk';
import _Icons24X24FilledLogoWhatsApp from '@sima-land/ui-quarks/icons/24x24/Filled/LogoWhatsApp';
import _Icons24X24FilledLogoYandex from '@sima-land/ui-quarks/icons/24x24/Filled/LogoYandex';
import _Icons24X24FilledLogoYandexSplit from '@sima-land/ui-quarks/icons/24x24/Filled/LogoYandexSplit';
import _Icons24X24FilledLogoYouTube from '@sima-land/ui-quarks/icons/24x24/Filled/LogoYouTube';
import _Icons24X24FilledMarkdown from '@sima-land/ui-quarks/icons/24x24/Filled/Markdown';
import _Icons24X24FilledMickey from '@sima-land/ui-quarks/icons/24x24/Filled/Mickey';
import _Icons24X24FilledMobile from '@sima-land/ui-quarks/icons/24x24/Filled/Mobile';
import _Icons24X24FilledMore from '@sima-land/ui-quarks/icons/24x24/Filled/More';
import _Icons24X24FilledMoreVert from '@sima-land/ui-quarks/icons/24x24/Filled/MoreVert';
import _Icons24X24FilledNotification from '@sima-land/ui-quarks/icons/24x24/Filled/Notification';
import _Icons24X24FilledPlay from '@sima-land/ui-quarks/icons/24x24/Filled/Play';
import _Icons24X24FilledPlayFrame from '@sima-land/ui-quarks/icons/24x24/Filled/PlayFrame';
import _Icons24X24FilledRadiobuttonSelected from '@sima-land/ui-quarks/icons/24x24/Filled/RadiobuttonSelected';
import _Icons24X24FilledSale from '@sima-land/ui-quarks/icons/24x24/Filled/Sale';
import _Icons24X24FilledSeptember from '@sima-land/ui-quarks/icons/24x24/Filled/September';
import _Icons24X24FilledShoulderStraps from '@sima-land/ui-quarks/icons/24x24/Filled/ShoulderStraps';
import _Icons24X24FilledSima from '@sima-land/ui-quarks/icons/24x24/Filled/Sima';
import _Icons24X24FilledSnowflake from '@sima-land/ui-quarks/icons/24x24/Filled/Snowflake';
import _Icons24X24FilledSpruce from '@sima-land/ui-quarks/icons/24x24/Filled/Spruce';
import _Icons24X24FilledStar from '@sima-land/ui-quarks/icons/24x24/Filled/Star';
import _Icons24X24FilledSun from '@sima-land/ui-quarks/icons/24x24/Filled/Sun';
import _Icons24X24FilledTank from '@sima-land/ui-quarks/icons/24x24/Filled/Tank';
import _Icons24X24FilledTm from '@sima-land/ui-quarks/icons/24x24/Filled/Tm';
import _Icons24X24FilledTulip from '@sima-land/ui-quarks/icons/24x24/Filled/Tulip';
import _Icons24X24FilledWedding from '@sima-land/ui-quarks/icons/24x24/Filled/Wedding';
import _Icons24X24StrokedApiKey from '@sima-land/ui-quarks/icons/24x24/Stroked/ApiKey';
import _Icons24X24StrokedArrowDown from '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowDown';
import _Icons24X24StrokedArrowExpandDown from '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowExpandDown';
import _Icons24X24StrokedArrowExpandLeft from '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowExpandLeft';
import _Icons24X24StrokedArrowExpandRight from '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowExpandRight';
import _Icons24X24StrokedArrowExpandUp from '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowExpandUp';
import _Icons24X24StrokedArrowLeft from '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowLeft';
import _Icons24X24StrokedArrowRight from '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowRight';
import _Icons24X24StrokedArrowUp from '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowUp';
import _Icons24X24StrokedBag from '@sima-land/ui-quarks/icons/24x24/Stroked/Bag';
import _Icons24X24StrokedBagCheck from '@sima-land/ui-quarks/icons/24x24/Stroked/BagCheck';
import _Icons24X24StrokedBagCross from '@sima-land/ui-quarks/icons/24x24/Stroked/BagCross';
import _Icons24X24StrokedBarcode from '@sima-land/ui-quarks/icons/24x24/Stroked/Barcode';
import _Icons24X24StrokedBinoculars from '@sima-land/ui-quarks/icons/24x24/Stroked/Binoculars';
import _Icons24X24StrokedBook from '@sima-land/ui-quarks/icons/24x24/Stroked/Book';
import _Icons24X24StrokedBox from '@sima-land/ui-quarks/icons/24x24/Stroked/Box';
import _Icons24X24StrokedBriefcase from '@sima-land/ui-quarks/icons/24x24/Stroked/Briefcase';
import _Icons24X24StrokedBurger from '@sima-land/ui-quarks/icons/24x24/Stroked/Burger';
import _Icons24X24StrokedCalendar from '@sima-land/ui-quarks/icons/24x24/Stroked/Calendar';
import _Icons24X24StrokedCamera from '@sima-land/ui-quarks/icons/24x24/Stroked/Camera';
import _Icons24X24StrokedCar from '@sima-land/ui-quarks/icons/24x24/Stroked/Car';
import _Icons24X24StrokedCard from '@sima-land/ui-quarks/icons/24x24/Stroked/Card';
import _Icons24X24StrokedCart from '@sima-land/ui-quarks/icons/24x24/Stroked/Cart';
import _Icons24X24StrokedCatalogSearch from '@sima-land/ui-quarks/icons/24x24/Stroked/CatalogSearch';
import _Icons24X24StrokedCertificate from '@sima-land/ui-quarks/icons/24x24/Stroked/Certificate';
import _Icons24X24StrokedCheck from '@sima-land/ui-quarks/icons/24x24/Stroked/Check';
import _Icons24X24StrokedClip from '@sima-land/ui-quarks/icons/24x24/Stroked/Clip';
import _Icons24X24StrokedCollapse from '@sima-land/ui-quarks/icons/24x24/Stroked/Collapse';
import _Icons24X24StrokedComparisonAdd from '@sima-land/ui-quarks/icons/24x24/Stroked/ComparisonAdd';
import _Icons24X24StrokedComparisonAdded from '@sima-land/ui-quarks/icons/24x24/Stroked/ComparisonAdded';
import _Icons24X24StrokedComparisonDelete from '@sima-land/ui-quarks/icons/24x24/Stroked/ComparisonDelete';
import _Icons24X24StrokedContacts from '@sima-land/ui-quarks/icons/24x24/Stroked/Contacts';
import _Icons24X24StrokedControls from '@sima-land/ui-quarks/icons/24x24/Stroked/Controls';
import _Icons24X24StrokedControlsMore from '@sima-land/ui-quarks/icons/24x24/Stroked/ControlsMore';
import _Icons24X24StrokedCopy from '@sima-land/ui-quarks/icons/24x24/Stroked/Copy';
import _Icons24X24StrokedCross from '@sima-land/ui-quarks/icons/24x24/Stroked/Cross';
import _Icons24X24StrokedCube from '@sima-land/ui-quarks/icons/24x24/Stroked/Cube';
import _Icons24X24StrokedDownload from '@sima-land/ui-quarks/icons/24x24/Stroked/Download';
import _Icons24X24StrokedEclipse from '@sima-land/ui-quarks/icons/24x24/Stroked/Eclipse';
import _Icons24X24StrokedEntrance from '@sima-land/ui-quarks/icons/24x24/Stroked/Entrance';
import _Icons24X24StrokedExit from '@sima-land/ui-quarks/icons/24x24/Stroked/Exit';
import _Icons24X24StrokedExpand from '@sima-land/ui-quarks/icons/24x24/Stroked/Expand';
import _Icons24X24StrokedExpandArrows from '@sima-land/ui-quarks/icons/24x24/Stroked/ExpandArrows';
import _Icons24X24StrokedEye from '@sima-land/ui-quarks/icons/24x24/Stroked/Eye';
import _Icons24X24StrokedEyeClosed from '@sima-land/ui-quarks/icons/24x24/Stroked/EyeClosed';
import _Icons24X24StrokedFaceId from '@sima-land/ui-quarks/icons/24x24/Stroked/FaceId';
import _Icons24X24StrokedFavorite from '@sima-land/ui-quarks/icons/24x24/Stroked/Favorite';
import _Icons24X24StrokedFile from '@sima-land/ui-quarks/icons/24x24/Stroked/File';
import _Icons24X24StrokedFileAdd from '@sima-land/ui-quarks/icons/24x24/Stroked/FileAdd';
import _Icons24X24StrokedFiles from '@sima-land/ui-quarks/icons/24x24/Stroked/Files';
import _Icons24X24StrokedFilterOther from '@sima-land/ui-quarks/icons/24x24/Stroked/FilterOther';
import _Icons24X24StrokedGear from '@sima-land/ui-quarks/icons/24x24/Stroked/Gear';
import _Icons24X24StrokedGenders from '@sima-land/ui-quarks/icons/24x24/Stroked/Genders';
import _Icons24X24StrokedGeoArrow from '@sima-land/ui-quarks/icons/24x24/Stroked/GeoArrow';
import _Icons24X24StrokedGift from '@sima-land/ui-quarks/icons/24x24/Stroked/Gift';
import _Icons24X24StrokedGiftCard from '@sima-land/ui-quarks/icons/24x24/Stroked/GiftCard';
import _Icons24X24StrokedGovernmentBuilding from '@sima-land/ui-quarks/icons/24x24/Stroked/GovernmentBuilding';
import _Icons24X24StrokedHanger from '@sima-land/ui-quarks/icons/24x24/Stroked/Hanger';
import _Icons24X24StrokedHeadset from '@sima-land/ui-quarks/icons/24x24/Stroked/Headset';
import _Icons24X24StrokedHelp from '@sima-land/ui-quarks/icons/24x24/Stroked/Help';
import _Icons24X24StrokedHome from '@sima-land/ui-quarks/icons/24x24/Stroked/Home';
import _Icons24X24StrokedInfo from '@sima-land/ui-quarks/icons/24x24/Stroked/Info';
import _Icons24X24StrokedLink from '@sima-land/ui-quarks/icons/24x24/Stroked/Link';
import _Icons24X24StrokedList from '@sima-land/ui-quarks/icons/24x24/Stroked/List';
import _Icons24X24StrokedLoader from '@sima-land/ui-quarks/icons/24x24/Stroked/Loader';
import _Icons24X24StrokedLocation from '@sima-land/ui-quarks/icons/24x24/Stroked/Location';
import _Icons24X24StrokedLock from '@sima-land/ui-quarks/icons/24x24/Stroked/Lock';
import _Icons24X24StrokedLogoChestnyZnak from '@sima-land/ui-quarks/icons/24x24/Stroked/LogoChestnyZnak';
import _Icons24X24StrokedLogoSima from '@sima-land/ui-quarks/icons/24x24/Stroked/LogoSima';
import _Icons24X24StrokedLogoSkype from '@sima-land/ui-quarks/icons/24x24/Stroked/LogoSkype';
import _Icons24X24StrokedMagnifier from '@sima-land/ui-quarks/icons/24x24/Stroked/Magnifier';
import _Icons24X24StrokedMagnifierPlus from '@sima-land/ui-quarks/icons/24x24/Stroked/MagnifierPlus';
import _Icons24X24StrokedMail from '@sima-land/ui-quarks/icons/24x24/Stroked/Mail';
import _Icons24X24StrokedMap from '@sima-land/ui-quarks/icons/24x24/Stroked/Map';
import _Icons24X24StrokedMarkHeart from '@sima-land/ui-quarks/icons/24x24/Stroked/MarkHeart';
import _Icons24X24StrokedMicrophone from '@sima-land/ui-quarks/icons/24x24/Stroked/Microphone';
import _Icons24X24StrokedMicrophoneOff from '@sima-land/ui-quarks/icons/24x24/Stroked/MicrophoneOff';
import _Icons24X24StrokedMinus from '@sima-land/ui-quarks/icons/24x24/Stroked/Minus';
import _Icons24X24StrokedMobile from '@sima-land/ui-quarks/icons/24x24/Stroked/Mobile';
import _Icons24X24StrokedMoon from '@sima-land/ui-quarks/icons/24x24/Stroked/Moon';
import _Icons24X24StrokedNoFavorite from '@sima-land/ui-quarks/icons/24x24/Stroked/NoFavorite';
import _Icons24X24StrokedNotification from '@sima-land/ui-quarks/icons/24x24/Stroked/Notification';
import _Icons24X24StrokedPencil from '@sima-land/ui-quarks/icons/24x24/Stroked/Pencil';
import _Icons24X24StrokedPercent from '@sima-land/ui-quarks/icons/24x24/Stroked/Percent';
import _Icons24X24StrokedPercentageSign from '@sima-land/ui-quarks/icons/24x24/Stroked/PercentageSign';
import _Icons24X24StrokedPerson from '@sima-land/ui-quarks/icons/24x24/Stroked/Person';
import _Icons24X24StrokedPhone from '@sima-land/ui-quarks/icons/24x24/Stroked/Phone';
import _Icons24X24StrokedPicture from '@sima-land/ui-quarks/icons/24x24/Stroked/Picture';
import _Icons24X24StrokedPlaceholder from '@sima-land/ui-quarks/icons/24x24/Stroked/Placeholder';
import _Icons24X24StrokedPlayCircle from '@sima-land/ui-quarks/icons/24x24/Stroked/PlayCircle';
import _Icons24X24StrokedPlus from '@sima-land/ui-quarks/icons/24x24/Stroked/Plus';
import _Icons24X24StrokedPlusCircle from '@sima-land/ui-quarks/icons/24x24/Stroked/PlusCircle';
import _Icons24X24StrokedProgress from '@sima-land/ui-quarks/icons/24x24/Stroked/Progress';
import _Icons24X24StrokedPromocode from '@sima-land/ui-quarks/icons/24x24/Stroked/Promocode';
import _Icons24X24StrokedRepeat from '@sima-land/ui-quarks/icons/24x24/Stroked/Repeat';
import _Icons24X24StrokedReturnUpBack from '@sima-land/ui-quarks/icons/24x24/Stroked/ReturnUpBack';
import _Icons24X24StrokedRubles from '@sima-land/ui-quarks/icons/24x24/Stroked/Rubles';
import _Icons24X24StrokedSalaryStatement from '@sima-land/ui-quarks/icons/24x24/Stroked/SalaryStatement';
import _Icons24X24StrokedScissors from '@sima-land/ui-quarks/icons/24x24/Stroked/Scissors';
import _Icons24X24StrokedScreamer from '@sima-land/ui-quarks/icons/24x24/Stroked/Screamer';
import _Icons24X24StrokedScrewdriver from '@sima-land/ui-quarks/icons/24x24/Stroked/Screwdriver';
import _Icons24X24StrokedShare from '@sima-land/ui-quarks/icons/24x24/Stroked/Share';
import _Icons24X24StrokedShareAndroid from '@sima-land/ui-quarks/icons/24x24/Stroked/ShareAndroid';
import _Icons24X24StrokedShareiOs from '@sima-land/ui-quarks/icons/24x24/Stroked/ShareiOs';
import _Icons24X24StrokedSort2 from '@sima-land/ui-quarks/icons/24x24/Stroked/Sort2';
import _Icons24X24StrokedSortUp from '@sima-land/ui-quarks/icons/24x24/Stroked/SortUp';
import _Icons24X24StrokedSpeaker from '@sima-land/ui-quarks/icons/24x24/Stroked/Speaker';
import _Icons24X24StrokedSpeakerOff from '@sima-land/ui-quarks/icons/24x24/Stroked/SpeakerOff';
import _Icons24X24StrokedSpeechBubble from '@sima-land/ui-quarks/icons/24x24/Stroked/SpeechBubble';
import _Icons24X24StrokedSpruce from '@sima-land/ui-quarks/icons/24x24/Stroked/Spruce';
import _Icons24X24StrokedStatement from '@sima-land/ui-quarks/icons/24x24/Stroked/Statement';
import _Icons24X24StrokedSun from '@sima-land/ui-quarks/icons/24x24/Stroked/Sun';
import _Icons24X24StrokedThermometer from '@sima-land/ui-quarks/icons/24x24/Stroked/Thermometer';
import _Icons24X24StrokedThumbsUp from '@sima-land/ui-quarks/icons/24x24/Stroked/ThumbsUp';
import _Icons24X24StrokedTooltip from '@sima-land/ui-quarks/icons/24x24/Stroked/Tooltip';
import _Icons24X24StrokedTooltipPlus from '@sima-land/ui-quarks/icons/24x24/Stroked/TooltipPlus';
import _Icons24X24StrokedTouchId from '@sima-land/ui-quarks/icons/24x24/Stroked/TouchId';
import _Icons24X24StrokedTrailer from '@sima-land/ui-quarks/icons/24x24/Stroked/Trailer';
import _Icons24X24StrokedTransfer from '@sima-land/ui-quarks/icons/24x24/Stroked/Transfer';
import _Icons24X24StrokedTrash from '@sima-land/ui-quarks/icons/24x24/Stroked/Trash';
import _Icons24X24StrokedUnitedCustomers from '@sima-land/ui-quarks/icons/24x24/Stroked/UnitedCustomers';
import _Icons24X24StrokedUnknownType from '@sima-land/ui-quarks/icons/24x24/Stroked/UnknownType';
import _Icons24X24StrokedUnlock from '@sima-land/ui-quarks/icons/24x24/Stroked/Unlock';
import _Icons24X24StrokedUpload from '@sima-land/ui-quarks/icons/24x24/Stroked/Upload';
import _Icons24X24StrokedViewCards from '@sima-land/ui-quarks/icons/24x24/Stroked/ViewCards';
import _Icons24X24StrokedViewGrid from '@sima-land/ui-quarks/icons/24x24/Stroked/ViewGrid';
import _Icons24X24StrokedViewLarge from '@sima-land/ui-quarks/icons/24x24/Stroked/ViewLarge';
import _Icons24X24StrokedViewList from '@sima-land/ui-quarks/icons/24x24/Stroked/ViewList';
import _Icons24X24StrokedViewQuick from '@sima-land/ui-quarks/icons/24x24/Stroked/ViewQuick';
import _Icons24X24StrokedWallet from '@sima-land/ui-quarks/icons/24x24/Stroked/Wallet';
import _Icons24X24StrokedWatch from '@sima-land/ui-quarks/icons/24x24/Stroked/Watch';
import _Icons32X32ColorfulLogo5Post from '@sima-land/ui-quarks/icons/32x32/Colorful/Logo5Post';
import _Icons32X32ColorfulLogoAptekaPlus from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoAptekaPlus';
import _Icons32X32ColorfulLogoBoxberry from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoBoxberry';
import _Icons32X32ColorfulLogoDalli from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoDalli';
import _Icons32X32ColorfulLogoDellin from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoDellin';
import _Icons32X32ColorfulLogoDpd from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoDpd';
import _Icons32X32ColorfulLogoGalamart from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoGalamart';
import _Icons32X32ColorfulLogoOzon from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoOzon';
import _Icons32X32ColorfulLogoPickPoint from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoPickPoint';
import _Icons32X32ColorfulLogoPost from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoPost';
import _Icons32X32ColorfulLogoSberLogistic from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSberLogistic';
import _Icons32X32ColorfulLogoSdek from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSdek';
import _Icons32X32ColorfulLogoSima from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSima';
import _Icons32X32ColorfulLogoSimaBlue from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSimaBlue';
import _Icons32X32ColorfulLogoSimaGreen from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSimaGreen';
import _Icons32X32ColorfulLogoSimaPurple from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSimaPurple';
import _Icons32X32ColorfulLogoYandex from '@sima-land/ui-quarks/icons/32x32/Colorful/LogoYandex';
import _Icons40X40FilledPause from '@sima-land/ui-quarks/icons/40x40/Filled/Pause';
import _Icons40X40FilledPlay from '@sima-land/ui-quarks/icons/40x40/Filled/Play';
import _Icons40X40FilledViewing360 from '@sima-land/ui-quarks/icons/40x40/Filled/Viewing360';
import _Icons40X40FilledViewing360Perspective from '@sima-land/ui-quarks/icons/40x40/Filled/Viewing360Perspective';
import _Icons40X40StrokedBrand from '@sima-land/ui-quarks/icons/40x40/Stroked/Brand';
import _Icons40X40StrokedCamera from '@sima-land/ui-quarks/icons/40x40/Stroked/Camera';
import _Icons40X40StrokedCup from '@sima-land/ui-quarks/icons/40x40/Stroked/Cup';
import _Icons40X40StrokedImageBroken from '@sima-land/ui-quarks/icons/40x40/Stroked/ImageBroken';
import _Icons40X40StrokedLock from '@sima-land/ui-quarks/icons/40x40/Stroked/Lock';
import _Icons40X40StrokedMap from '@sima-land/ui-quarks/icons/40x40/Stroked/Map';
import _Icons40X40StrokedMatryoshka from '@sima-land/ui-quarks/icons/40x40/Stroked/Matryoshka';
import _Icons40X40StrokedPaymentCards from '@sima-land/ui-quarks/icons/40x40/Stroked/PaymentCards';
import _Icons40X40StrokedPaymentCash from '@sima-land/ui-quarks/icons/40x40/Stroked/PaymentCash';
import _Icons40X40StrokedPaymentCheck from '@sima-land/ui-quarks/icons/40x40/Stroked/PaymentCheck';
import _Icons40X40StrokedPaymentMoney from '@sima-land/ui-quarks/icons/40x40/Stroked/PaymentMoney';
import _Icons40X40StrokedPeople from '@sima-land/ui-quarks/icons/40x40/Stroked/People';
import _Icons40X40StrokedPlanet from '@sima-land/ui-quarks/icons/40x40/Stroked/Planet';
import _Icons40X40StrokedPlayRound from '@sima-land/ui-quarks/icons/40x40/Stroked/PlayRound';
import _Icons40X40StrokedProducts from '@sima-land/ui-quarks/icons/40x40/Stroked/Products';
import _Icons40X40StrokedPurchases from '@sima-land/ui-quarks/icons/40x40/Stroked/Purchases';
import _Icons40X40StrokedSad from '@sima-land/ui-quarks/icons/40x40/Stroked/Sad';
import _Icons40X40StrokedSquares from '@sima-land/ui-quarks/icons/40x40/Stroked/Squares';
import _Icons40X40StrokedTimer from '@sima-land/ui-quarks/icons/40x40/Stroked/Timer';
import _Icons40X40StrokedTooltipLike from '@sima-land/ui-quarks/icons/40x40/Stroked/TooltipLike';
import _Icons64X64ColorfulTouchScrollX from '@sima-land/ui-quarks/icons/64x64/Colorful/TouchScrollX';
import _Icons64X64StrokedEighteenPlus from '@sima-land/ui-quarks/icons/64x64/Stroked/EighteenPlus';
import _Icons64X64StrokedUpload from '@sima-land/ui-quarks/icons/64x64/Stroked/Upload';

export const icons = [
  
{
  component: _Icons16X16ColorfulLogo5Post,
  componentName: 'Logo5PostSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/Logo5Post',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'Logo5Post',
}
,

{
  component: _Icons16X16ColorfulLogoAptekaPlus,
  componentName: 'LogoAptekaPlusSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoAptekaPlus',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoAptekaPlus',
}
,

{
  component: _Icons16X16ColorfulLogoAvitoSima,
  componentName: 'LogoAvitoSimaSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoAvitoSima',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoAvitoSima',
}
,

{
  component: _Icons16X16ColorfulLogoBoxberry,
  componentName: 'LogoBoxberrySVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoBoxberry',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoBoxberry',
}
,

{
  component: _Icons16X16ColorfulLogoDalli,
  componentName: 'LogoDalliSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoDalli',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoDalli',
}
,

{
  component: _Icons16X16ColorfulLogoDellin,
  componentName: 'LogoDellinSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoDellin',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoDellin',
}
,

{
  component: _Icons16X16ColorfulLogoDpd,
  componentName: 'LogoDpdSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoDpd',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoDpd',
}
,

{
  component: _Icons16X16ColorfulLogoGalamart,
  componentName: 'LogoGalamartSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoGalamart',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoGalamart',
}
,

{
  component: _Icons16X16ColorfulLogoOzon,
  componentName: 'LogoOzonSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoOzon',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoOzon',
}
,

{
  component: _Icons16X16ColorfulLogoOzonSima,
  componentName: 'LogoOzonSimaSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoOzonSima',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoOzonSima',
}
,

{
  component: _Icons16X16ColorfulLogoPickPoint,
  componentName: 'LogoPickPointSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoPickPoint',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoPickPoint',
}
,

{
  component: _Icons16X16ColorfulLogoPost,
  componentName: 'LogoPostSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoPost',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoPost',
}
,

{
  component: _Icons16X16ColorfulLogoSberLogistic,
  componentName: 'LogoSberLogisticSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoSberLogistic',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoSberLogistic',
}
,

{
  component: _Icons16X16ColorfulLogoSdek,
  componentName: 'LogoSdekSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoSdek',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoSdek',
}
,

{
  component: _Icons16X16ColorfulLogoSima,
  componentName: 'LogoSimaSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoSima',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoSima',
}
,

{
  component: _Icons16X16ColorfulLogoWildberriesSima,
  componentName: 'LogoWildberriesSimaSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoWildberriesSima',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoWildberriesSima',
}
,

{
  component: _Icons16X16ColorfulLogoYandex,
  componentName: 'LogoYandexSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Colorful/LogoYandex',
  packagePathname: 'icons/16x16/Colorful',
  packageFilename: 'LogoYandex',
}
,

{
  component: _Icons16X16FilledCamera,
  componentName: 'CameraSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Camera',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Camera',
}
,

{
  component: _Icons16X16FilledCircleAdd,
  componentName: 'CircleAddSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/CircleAdd',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'CircleAdd',
}
,

{
  component: _Icons16X16FilledCircleCheck,
  componentName: 'CircleCheckSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/CircleCheck',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'CircleCheck',
}
,

{
  component: _Icons16X16FilledCircleCross,
  componentName: 'CircleCrossSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/CircleCross',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'CircleCross',
}
,

{
  component: _Icons16X16FilledDolphin,
  componentName: 'DolphinSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Dolphin',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Dolphin',
}
,

{
  component: _Icons16X16FilledEye,
  componentName: 'EyeSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Eye',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Eye',
}
,

{
  component: _Icons16X16FilledFunnel,
  componentName: 'FunnelSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Funnel',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Funnel',
}
,

{
  component: _Icons16X16FilledGeoArrow,
  componentName: 'GeoArrowSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/GeoArrow',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'GeoArrow',
}
,

{
  component: _Icons16X16FilledHeart,
  componentName: 'HeartSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Heart',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Heart',
}
,

{
  component: _Icons16X16FilledPerson,
  componentName: 'PersonSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Person',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Person',
}
,

{
  component: _Icons16X16FilledPlace,
  componentName: 'PlaceSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Place',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Place',
}
,

{
  component: _Icons16X16FilledShare,
  componentName: 'ShareSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Share',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Share',
}
,

{
  component: _Icons16X16FilledSortDown,
  componentName: 'SortDownSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/SortDown',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'SortDown',
}
,

{
  component: _Icons16X16FilledSortUp,
  componentName: 'SortUpSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/SortUp',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'SortUp',
}
,

{
  component: _Icons16X16FilledSpeechBubble,
  componentName: 'SpeechBubbleSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/SpeechBubble',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'SpeechBubble',
}
,

{
  component: _Icons16X16FilledStar,
  componentName: 'StarSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Star',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Star',
}
,

{
  component: _Icons16X16FilledThumbDown,
  componentName: 'ThumbDownSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/ThumbDown',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'ThumbDown',
}
,

{
  component: _Icons16X16FilledThumbUp,
  componentName: 'ThumbUpSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/ThumbUp',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'ThumbUp',
}
,

{
  component: _Icons16X16FilledTooltip,
  componentName: 'TooltipSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Tooltip',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Tooltip',
}
,

{
  component: _Icons16X16FilledTrash,
  componentName: 'TrashSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Trash',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Trash',
}
,

{
  component: _Icons16X16FilledWallet,
  componentName: 'WalletSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Filled/Wallet',
  packagePathname: 'icons/16x16/Filled',
  packageFilename: 'Wallet',
}
,

{
  component: _Icons16X16StrokedAdd,
  componentName: 'AddSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Add',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Add',
}
,

{
  component: _Icons16X16StrokedArrowDown,
  componentName: 'ArrowDownSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowDown',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowDown',
}
,

{
  component: _Icons16X16StrokedArrowDownSquare,
  componentName: 'ArrowDownSquareSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowDownSquare',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowDownSquare',
}
,

{
  component: _Icons16X16StrokedArrowExpandDown,
  componentName: 'ArrowExpandDownSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowExpandDown',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowExpandDown',
}
,

{
  component: _Icons16X16StrokedArrowExpandLeft,
  componentName: 'ArrowExpandLeftSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowExpandLeft',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowExpandLeft',
}
,

{
  component: _Icons16X16StrokedArrowExpandRight,
  componentName: 'ArrowExpandRightSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowExpandRight',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowExpandRight',
}
,

{
  component: _Icons16X16StrokedArrowExpandUp,
  componentName: 'ArrowExpandUpSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowExpandUp',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowExpandUp',
}
,

{
  component: _Icons16X16StrokedArrowLeft,
  componentName: 'ArrowLeftSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowLeft',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowLeft',
}
,

{
  component: _Icons16X16StrokedArrowRight,
  componentName: 'ArrowRightSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowRight',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowRight',
}
,

{
  component: _Icons16X16StrokedArrowTurnLeft,
  componentName: 'ArrowTurnLeftSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowTurnLeft',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowTurnLeft',
}
,

{
  component: _Icons16X16StrokedArrowTurnRight,
  componentName: 'ArrowTurnRightSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowTurnRight',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowTurnRight',
}
,

{
  component: _Icons16X16StrokedArrowUp,
  componentName: 'ArrowUpSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowUp',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowUp',
}
,

{
  component: _Icons16X16StrokedArrowUpAndDown,
  componentName: 'ArrowUpAndDownSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ArrowUpAndDown',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ArrowUpAndDown',
}
,

{
  component: _Icons16X16StrokedBurger,
  componentName: 'BurgerSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Burger',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Burger',
}
,

{
  component: _Icons16X16StrokedCart,
  componentName: 'CartSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Cart',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Cart',
}
,

{
  component: _Icons16X16StrokedCheck,
  componentName: 'CheckSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Check',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Check',
}
,

{
  component: _Icons16X16StrokedCopy,
  componentName: 'CopySVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Copy',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Copy',
}
,

{
  component: _Icons16X16StrokedCross,
  componentName: 'CrossSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Cross',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Cross',
}
,

{
  component: _Icons16X16StrokedExpandArrows,
  componentName: 'ExpandArrowsSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/ExpandArrows',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'ExpandArrows',
}
,

{
  component: _Icons16X16StrokedInformation,
  componentName: 'InformationSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Information',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Information',
}
,

{
  component: _Icons16X16StrokedLock,
  componentName: 'LockSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Lock',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Lock',
}
,

{
  component: _Icons16X16StrokedMinus,
  componentName: 'MinusSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Minus',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Minus',
}
,

{
  component: _Icons16X16StrokedPlaceholder,
  componentName: 'PlaceholderSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Placeholder',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Placeholder',
}
,

{
  component: _Icons16X16StrokedPlus,
  componentName: 'PlusSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Plus',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Plus',
}
,

{
  component: _Icons16X16StrokedRemove,
  componentName: 'RemoveSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Remove',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Remove',
}
,

{
  component: _Icons16X16StrokedScreamer,
  componentName: 'ScreamerSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Screamer',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Screamer',
}
,

{
  component: _Icons16X16StrokedVariation,
  componentName: 'VariationSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Variation',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Variation',
}
,

{
  component: _Icons16X16StrokedWatch,
  componentName: 'WatchSVG',
  importPath: '@sima-land/ui-quarks/icons/16x16/Stroked/Watch',
  packagePathname: 'icons/16x16/Stroked',
  packageFilename: 'Watch',
}
,

{
  component: _Icons24X24ColorfulLink,
  componentName: 'LinkSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/Link',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'Link',
}
,

{
  component: _Icons24X24ColorfulLinkCheck,
  componentName: 'LinkCheckSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LinkCheck',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LinkCheck',
}
,

{
  component: _Icons24X24ColorfulLogoDolyame,
  componentName: 'LogoDolyameSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoDolyame',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoDolyame',
}
,

{
  component: _Icons24X24ColorfulLogoFacebook,
  componentName: 'LogoFacebookSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoFacebook',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoFacebook',
}
,

{
  component: _Icons24X24ColorfulLogoJcb,
  componentName: 'LogoJcbSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoJcb',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoJcb',
}
,

{
  component: _Icons24X24ColorfulLogoMaestro,
  componentName: 'LogoMaestroSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoMaestro',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoMaestro',
}
,

{
  component: _Icons24X24ColorfulLogoMastercard,
  componentName: 'LogoMastercardSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoMastercard',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoMastercard',
}
,

{
  component: _Icons24X24ColorfulLogoMir,
  componentName: 'LogoMirSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoMir',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoMir',
}
,

{
  component: _Icons24X24ColorfulLogoOk,
  componentName: 'LogoOkSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoOk',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoOk',
}
,

{
  component: _Icons24X24ColorfulLogoPlatiChastyami,
  componentName: 'LogoPlatiChastyamiSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoPlatiChastyami',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoPlatiChastyami',
}
,

{
  component: _Icons24X24ColorfulLogoPodeli,
  componentName: 'LogoPodeliSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoPodeli',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoPodeli',
}
,

{
  component: _Icons24X24ColorfulLogoSber,
  componentName: 'LogoSberSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoSber',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoSber',
}
,

{
  component: _Icons24X24ColorfulLogoSberCredit,
  componentName: 'LogoSberCreditSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoSberCredit',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoSberCredit',
}
,

{
  component: _Icons24X24ColorfulLogoSbp,
  componentName: 'LogoSbpSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoSbp',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoSbp',
}
,

{
  component: _Icons24X24ColorfulLogoTelegram,
  componentName: 'LogoTelegramSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoTelegram',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoTelegram',
}
,

{
  component: _Icons24X24ColorfulLogoTwitter,
  componentName: 'LogoTwitterSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoTwitter',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoTwitter',
}
,

{
  component: _Icons24X24ColorfulLogoUnionPay,
  componentName: 'LogoUnionPaySVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoUnionPay',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoUnionPay',
}
,

{
  component: _Icons24X24ColorfulLogoViber,
  componentName: 'LogoViberSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoViber',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoViber',
}
,

{
  component: _Icons24X24ColorfulLogoVisa,
  componentName: 'LogoVisaSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVisa',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoVisa',
}
,

{
  component: _Icons24X24ColorfulLogoVisaDarkMode,
  componentName: 'LogoVisaDarkModeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVisaDarkMode',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoVisaDarkMode',
}
,

{
  component: _Icons24X24ColorfulLogoVk,
  componentName: 'LogoVkSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVk',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoVk',
}
,

{
  component: _Icons24X24ColorfulLogoVsegdaDa,
  componentName: 'LogoVsegdaDaSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVsegdaDa',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoVsegdaDa',
}
,

{
  component: _Icons24X24ColorfulLogoVsegdaDaDarkMode,
  componentName: 'LogoVsegdaDaDarkModeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoVsegdaDaDarkMode',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoVsegdaDaDarkMode',
}
,

{
  component: _Icons24X24ColorfulLogoWhatsApp,
  componentName: 'LogoWhatsAppSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoWhatsApp',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoWhatsApp',
}
,

{
  component: _Icons24X24ColorfulLogoYandexPlus,
  componentName: 'LogoYandexPlusSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoYandexPlus',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoYandexPlus',
}
,

{
  component: _Icons24X24ColorfulLogoYandexSplit,
  componentName: 'LogoYandexSplitSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Colorful/LogoYandexSplit',
  packagePathname: 'icons/24x24/Colorful',
  packageFilename: 'LogoYandexSplit',
}
,

{
  component: _Icons24X24FilledBall,
  componentName: 'BallSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Ball',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Ball',
}
,

{
  component: _Icons24X24FilledBlazon,
  componentName: 'BlazonSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Blazon',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Blazon',
}
,

{
  component: _Icons24X24FilledBusiness,
  componentName: 'BusinessSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Business',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Business',
}
,

{
  component: _Icons24X24FilledCard,
  componentName: 'CardSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Card',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Card',
}
,

{
  component: _Icons24X24FilledCircleCheck,
  componentName: 'CircleCheckSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/CircleCheck',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'CircleCheck',
}
,

{
  component: _Icons24X24FilledCircleCross,
  componentName: 'CircleCrossSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/CircleCross',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'CircleCross',
}
,

{
  component: _Icons24X24FilledCrown,
  componentName: 'CrownSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Crown',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Crown',
}
,

{
  component: _Icons24X24FilledEgg,
  componentName: 'EggSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Egg',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Egg',
}
,

{
  component: _Icons24X24FilledFavorite,
  componentName: 'FavoriteSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Favorite',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Favorite',
}
,

{
  component: _Icons24X24FilledFlash,
  componentName: 'FlashSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Flash',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Flash',
}
,

{
  component: _Icons24X24FilledFlower,
  componentName: 'FlowerSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Flower',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Flower',
}
,

{
  component: _Icons24X24FilledHalloween,
  componentName: 'HalloweenSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Halloween',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Halloween',
}
,

{
  component: _Icons24X24FilledHat,
  componentName: 'HatSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Hat',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Hat',
}
,

{
  component: _Icons24X24FilledHeart,
  componentName: 'HeartSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Heart',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Heart',
}
,

{
  component: _Icons24X24FilledLogoDzen,
  componentName: 'LogoDzenSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoDzen',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoDzen',
}
,

{
  component: _Icons24X24FilledLogoFacebook,
  componentName: 'LogoFacebookSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoFacebook',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoFacebook',
}
,

{
  component: _Icons24X24FilledLogoGoogle,
  componentName: 'LogoGoogleSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoGoogle',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoGoogle',
}
,

{
  component: _Icons24X24FilledLogoInspiration,
  componentName: 'LogoInspirationSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoInspiration',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoInspiration',
}
,

{
  component: _Icons24X24FilledLogoInstagram,
  componentName: 'LogoInstagramSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoInstagram',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoInstagram',
}
,

{
  component: _Icons24X24FilledLogoMail,
  componentName: 'LogoMailSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoMail',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoMail',
}
,

{
  component: _Icons24X24FilledLogoOk,
  componentName: 'LogoOkSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoOk',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoOk',
}
,

{
  component: _Icons24X24FilledLogoSkype,
  componentName: 'LogoSkypeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoSkype',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoSkype',
}
,

{
  component: _Icons24X24FilledLogoTelegram,
  componentName: 'LogoTelegramSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoTelegram',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoTelegram',
}
,

{
  component: _Icons24X24FilledLogoTikTok,
  componentName: 'LogoTikTokSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoTikTok',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoTikTok',
}
,

{
  component: _Icons24X24FilledLogoTwitter,
  componentName: 'LogoTwitterSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoTwitter',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoTwitter',
}
,

{
  component: _Icons24X24FilledLogoViber,
  componentName: 'LogoViberSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoViber',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoViber',
}
,

{
  component: _Icons24X24FilledLogoVk,
  componentName: 'LogoVkSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoVk',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoVk',
}
,

{
  component: _Icons24X24FilledLogoWhatsApp,
  componentName: 'LogoWhatsAppSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoWhatsApp',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoWhatsApp',
}
,

{
  component: _Icons24X24FilledLogoYandex,
  componentName: 'LogoYandexSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoYandex',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoYandex',
}
,

{
  component: _Icons24X24FilledLogoYandexSplit,
  componentName: 'LogoYandexSplitSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoYandexSplit',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoYandexSplit',
}
,

{
  component: _Icons24X24FilledLogoYouTube,
  componentName: 'LogoYouTubeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/LogoYouTube',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'LogoYouTube',
}
,

{
  component: _Icons24X24FilledMarkdown,
  componentName: 'MarkdownSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Markdown',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Markdown',
}
,

{
  component: _Icons24X24FilledMickey,
  componentName: 'MickeySVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Mickey',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Mickey',
}
,

{
  component: _Icons24X24FilledMobile,
  componentName: 'MobileSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Mobile',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Mobile',
}
,

{
  component: _Icons24X24FilledMore,
  componentName: 'MoreSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/More',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'More',
}
,

{
  component: _Icons24X24FilledMoreVert,
  componentName: 'MoreVertSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/MoreVert',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'MoreVert',
}
,

{
  component: _Icons24X24FilledNotification,
  componentName: 'NotificationSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Notification',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Notification',
}
,

{
  component: _Icons24X24FilledPlay,
  componentName: 'PlaySVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Play',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Play',
}
,

{
  component: _Icons24X24FilledPlayFrame,
  componentName: 'PlayFrameSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/PlayFrame',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'PlayFrame',
}
,

{
  component: _Icons24X24FilledRadiobuttonSelected,
  componentName: 'RadiobuttonSelectedSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/RadiobuttonSelected',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'RadiobuttonSelected',
}
,

{
  component: _Icons24X24FilledSale,
  componentName: 'SaleSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Sale',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Sale',
}
,

{
  component: _Icons24X24FilledSeptember,
  componentName: 'SeptemberSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/September',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'September',
}
,

{
  component: _Icons24X24FilledShoulderStraps,
  componentName: 'ShoulderStrapsSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/ShoulderStraps',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'ShoulderStraps',
}
,

{
  component: _Icons24X24FilledSima,
  componentName: 'SimaSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Sima',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Sima',
}
,

{
  component: _Icons24X24FilledSnowflake,
  componentName: 'SnowflakeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Snowflake',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Snowflake',
}
,

{
  component: _Icons24X24FilledSpruce,
  componentName: 'SpruceSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Spruce',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Spruce',
}
,

{
  component: _Icons24X24FilledStar,
  componentName: 'StarSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Star',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Star',
}
,

{
  component: _Icons24X24FilledSun,
  componentName: 'SunSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Sun',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Sun',
}
,

{
  component: _Icons24X24FilledTank,
  componentName: 'TankSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Tank',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Tank',
}
,

{
  component: _Icons24X24FilledTm,
  componentName: 'TmSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Tm',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Tm',
}
,

{
  component: _Icons24X24FilledTulip,
  componentName: 'TulipSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Tulip',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Tulip',
}
,

{
  component: _Icons24X24FilledWedding,
  componentName: 'WeddingSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Filled/Wedding',
  packagePathname: 'icons/24x24/Filled',
  packageFilename: 'Wedding',
}
,

{
  component: _Icons24X24StrokedApiKey,
  componentName: 'ApiKeySVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ApiKey',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ApiKey',
}
,

{
  component: _Icons24X24StrokedArrowDown,
  componentName: 'ArrowDownSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowDown',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ArrowDown',
}
,

{
  component: _Icons24X24StrokedArrowExpandDown,
  componentName: 'ArrowExpandDownSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowExpandDown',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ArrowExpandDown',
}
,

{
  component: _Icons24X24StrokedArrowExpandLeft,
  componentName: 'ArrowExpandLeftSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowExpandLeft',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ArrowExpandLeft',
}
,

{
  component: _Icons24X24StrokedArrowExpandRight,
  componentName: 'ArrowExpandRightSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowExpandRight',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ArrowExpandRight',
}
,

{
  component: _Icons24X24StrokedArrowExpandUp,
  componentName: 'ArrowExpandUpSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowExpandUp',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ArrowExpandUp',
}
,

{
  component: _Icons24X24StrokedArrowLeft,
  componentName: 'ArrowLeftSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowLeft',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ArrowLeft',
}
,

{
  component: _Icons24X24StrokedArrowRight,
  componentName: 'ArrowRightSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowRight',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ArrowRight',
}
,

{
  component: _Icons24X24StrokedArrowUp,
  componentName: 'ArrowUpSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ArrowUp',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ArrowUp',
}
,

{
  component: _Icons24X24StrokedBag,
  componentName: 'BagSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Bag',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Bag',
}
,

{
  component: _Icons24X24StrokedBagCheck,
  componentName: 'BagCheckSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/BagCheck',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'BagCheck',
}
,

{
  component: _Icons24X24StrokedBagCross,
  componentName: 'BagCrossSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/BagCross',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'BagCross',
}
,

{
  component: _Icons24X24StrokedBarcode,
  componentName: 'BarcodeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Barcode',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Barcode',
}
,

{
  component: _Icons24X24StrokedBinoculars,
  componentName: 'BinocularsSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Binoculars',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Binoculars',
}
,

{
  component: _Icons24X24StrokedBook,
  componentName: 'BookSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Book',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Book',
}
,

{
  component: _Icons24X24StrokedBox,
  componentName: 'BoxSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Box',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Box',
}
,

{
  component: _Icons24X24StrokedBriefcase,
  componentName: 'BriefcaseSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Briefcase',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Briefcase',
}
,

{
  component: _Icons24X24StrokedBurger,
  componentName: 'BurgerSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Burger',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Burger',
}
,

{
  component: _Icons24X24StrokedCalendar,
  componentName: 'CalendarSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Calendar',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Calendar',
}
,

{
  component: _Icons24X24StrokedCamera,
  componentName: 'CameraSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Camera',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Camera',
}
,

{
  component: _Icons24X24StrokedCar,
  componentName: 'CarSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Car',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Car',
}
,

{
  component: _Icons24X24StrokedCard,
  componentName: 'CardSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Card',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Card',
}
,

{
  component: _Icons24X24StrokedCart,
  componentName: 'CartSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Cart',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Cart',
}
,

{
  component: _Icons24X24StrokedCatalogSearch,
  componentName: 'CatalogSearchSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/CatalogSearch',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'CatalogSearch',
}
,

{
  component: _Icons24X24StrokedCertificate,
  componentName: 'CertificateSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Certificate',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Certificate',
}
,

{
  component: _Icons24X24StrokedCheck,
  componentName: 'CheckSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Check',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Check',
}
,

{
  component: _Icons24X24StrokedClip,
  componentName: 'ClipSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Clip',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Clip',
}
,

{
  component: _Icons24X24StrokedCollapse,
  componentName: 'CollapseSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Collapse',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Collapse',
}
,

{
  component: _Icons24X24StrokedComparisonAdd,
  componentName: 'ComparisonAddSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ComparisonAdd',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ComparisonAdd',
}
,

{
  component: _Icons24X24StrokedComparisonAdded,
  componentName: 'ComparisonAddedSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ComparisonAdded',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ComparisonAdded',
}
,

{
  component: _Icons24X24StrokedComparisonDelete,
  componentName: 'ComparisonDeleteSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ComparisonDelete',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ComparisonDelete',
}
,

{
  component: _Icons24X24StrokedContacts,
  componentName: 'ContactsSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Contacts',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Contacts',
}
,

{
  component: _Icons24X24StrokedControls,
  componentName: 'ControlsSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Controls',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Controls',
}
,

{
  component: _Icons24X24StrokedControlsMore,
  componentName: 'ControlsMoreSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ControlsMore',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ControlsMore',
}
,

{
  component: _Icons24X24StrokedCopy,
  componentName: 'CopySVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Copy',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Copy',
}
,

{
  component: _Icons24X24StrokedCross,
  componentName: 'CrossSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Cross',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Cross',
}
,

{
  component: _Icons24X24StrokedCube,
  componentName: 'CubeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Cube',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Cube',
}
,

{
  component: _Icons24X24StrokedDownload,
  componentName: 'DownloadSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Download',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Download',
}
,

{
  component: _Icons24X24StrokedEclipse,
  componentName: 'EclipseSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Eclipse',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Eclipse',
}
,

{
  component: _Icons24X24StrokedEntrance,
  componentName: 'EntranceSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Entrance',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Entrance',
}
,

{
  component: _Icons24X24StrokedExit,
  componentName: 'ExitSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Exit',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Exit',
}
,

{
  component: _Icons24X24StrokedExpand,
  componentName: 'ExpandSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Expand',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Expand',
}
,

{
  component: _Icons24X24StrokedExpandArrows,
  componentName: 'ExpandArrowsSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ExpandArrows',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ExpandArrows',
}
,

{
  component: _Icons24X24StrokedEye,
  componentName: 'EyeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Eye',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Eye',
}
,

{
  component: _Icons24X24StrokedEyeClosed,
  componentName: 'EyeClosedSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/EyeClosed',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'EyeClosed',
}
,

{
  component: _Icons24X24StrokedFaceId,
  componentName: 'FaceIdSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/FaceId',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'FaceId',
}
,

{
  component: _Icons24X24StrokedFavorite,
  componentName: 'FavoriteSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Favorite',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Favorite',
}
,

{
  component: _Icons24X24StrokedFile,
  componentName: 'FileSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/File',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'File',
}
,

{
  component: _Icons24X24StrokedFileAdd,
  componentName: 'FileAddSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/FileAdd',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'FileAdd',
}
,

{
  component: _Icons24X24StrokedFiles,
  componentName: 'FilesSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Files',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Files',
}
,

{
  component: _Icons24X24StrokedFilterOther,
  componentName: 'FilterOtherSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/FilterOther',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'FilterOther',
}
,

{
  component: _Icons24X24StrokedGear,
  componentName: 'GearSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Gear',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Gear',
}
,

{
  component: _Icons24X24StrokedGenders,
  componentName: 'GendersSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Genders',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Genders',
}
,

{
  component: _Icons24X24StrokedGeoArrow,
  componentName: 'GeoArrowSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/GeoArrow',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'GeoArrow',
}
,

{
  component: _Icons24X24StrokedGift,
  componentName: 'GiftSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Gift',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Gift',
}
,

{
  component: _Icons24X24StrokedGiftCard,
  componentName: 'GiftCardSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/GiftCard',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'GiftCard',
}
,

{
  component: _Icons24X24StrokedGovernmentBuilding,
  componentName: 'GovernmentBuildingSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/GovernmentBuilding',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'GovernmentBuilding',
}
,

{
  component: _Icons24X24StrokedHanger,
  componentName: 'HangerSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Hanger',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Hanger',
}
,

{
  component: _Icons24X24StrokedHeadset,
  componentName: 'HeadsetSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Headset',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Headset',
}
,

{
  component: _Icons24X24StrokedHelp,
  componentName: 'HelpSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Help',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Help',
}
,

{
  component: _Icons24X24StrokedHome,
  componentName: 'HomeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Home',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Home',
}
,

{
  component: _Icons24X24StrokedInfo,
  componentName: 'InfoSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Info',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Info',
}
,

{
  component: _Icons24X24StrokedLink,
  componentName: 'LinkSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Link',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Link',
}
,

{
  component: _Icons24X24StrokedList,
  componentName: 'ListSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/List',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'List',
}
,

{
  component: _Icons24X24StrokedLoader,
  componentName: 'LoaderSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Loader',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Loader',
}
,

{
  component: _Icons24X24StrokedLocation,
  componentName: 'LocationSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Location',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Location',
}
,

{
  component: _Icons24X24StrokedLock,
  componentName: 'LockSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Lock',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Lock',
}
,

{
  component: _Icons24X24StrokedLogoChestnyZnak,
  componentName: 'LogoChestnyZnakSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/LogoChestnyZnak',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'LogoChestnyZnak',
}
,

{
  component: _Icons24X24StrokedLogoSima,
  componentName: 'LogoSimaSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/LogoSima',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'LogoSima',
}
,

{
  component: _Icons24X24StrokedLogoSkype,
  componentName: 'LogoSkypeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/LogoSkype',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'LogoSkype',
}
,

{
  component: _Icons24X24StrokedMagnifier,
  componentName: 'MagnifierSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Magnifier',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Magnifier',
}
,

{
  component: _Icons24X24StrokedMagnifierPlus,
  componentName: 'MagnifierPlusSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/MagnifierPlus',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'MagnifierPlus',
}
,

{
  component: _Icons24X24StrokedMail,
  componentName: 'MailSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Mail',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Mail',
}
,

{
  component: _Icons24X24StrokedMap,
  componentName: 'MapSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Map',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Map',
}
,

{
  component: _Icons24X24StrokedMarkHeart,
  componentName: 'MarkHeartSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/MarkHeart',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'MarkHeart',
}
,

{
  component: _Icons24X24StrokedMicrophone,
  componentName: 'MicrophoneSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Microphone',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Microphone',
}
,

{
  component: _Icons24X24StrokedMicrophoneOff,
  componentName: 'MicrophoneOffSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/MicrophoneOff',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'MicrophoneOff',
}
,

{
  component: _Icons24X24StrokedMinus,
  componentName: 'MinusSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Minus',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Minus',
}
,

{
  component: _Icons24X24StrokedMobile,
  componentName: 'MobileSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Mobile',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Mobile',
}
,

{
  component: _Icons24X24StrokedMoon,
  componentName: 'MoonSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Moon',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Moon',
}
,

{
  component: _Icons24X24StrokedNoFavorite,
  componentName: 'NoFavoriteSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/NoFavorite',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'NoFavorite',
}
,

{
  component: _Icons24X24StrokedNotification,
  componentName: 'NotificationSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Notification',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Notification',
}
,

{
  component: _Icons24X24StrokedPencil,
  componentName: 'PencilSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Pencil',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Pencil',
}
,

{
  component: _Icons24X24StrokedPercent,
  componentName: 'PercentSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Percent',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Percent',
}
,

{
  component: _Icons24X24StrokedPercentageSign,
  componentName: 'PercentageSignSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/PercentageSign',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'PercentageSign',
}
,

{
  component: _Icons24X24StrokedPerson,
  componentName: 'PersonSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Person',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Person',
}
,

{
  component: _Icons24X24StrokedPhone,
  componentName: 'PhoneSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Phone',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Phone',
}
,

{
  component: _Icons24X24StrokedPicture,
  componentName: 'PictureSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Picture',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Picture',
}
,

{
  component: _Icons24X24StrokedPlaceholder,
  componentName: 'PlaceholderSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Placeholder',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Placeholder',
}
,

{
  component: _Icons24X24StrokedPlayCircle,
  componentName: 'PlayCircleSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/PlayCircle',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'PlayCircle',
}
,

{
  component: _Icons24X24StrokedPlus,
  componentName: 'PlusSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Plus',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Plus',
}
,

{
  component: _Icons24X24StrokedPlusCircle,
  componentName: 'PlusCircleSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/PlusCircle',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'PlusCircle',
}
,

{
  component: _Icons24X24StrokedProgress,
  componentName: 'ProgressSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Progress',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Progress',
}
,

{
  component: _Icons24X24StrokedPromocode,
  componentName: 'PromocodeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Promocode',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Promocode',
}
,

{
  component: _Icons24X24StrokedRepeat,
  componentName: 'RepeatSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Repeat',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Repeat',
}
,

{
  component: _Icons24X24StrokedReturnUpBack,
  componentName: 'ReturnUpBackSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ReturnUpBack',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ReturnUpBack',
}
,

{
  component: _Icons24X24StrokedRubles,
  componentName: 'RublesSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Rubles',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Rubles',
}
,

{
  component: _Icons24X24StrokedSalaryStatement,
  componentName: 'SalaryStatementSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/SalaryStatement',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'SalaryStatement',
}
,

{
  component: _Icons24X24StrokedScissors,
  componentName: 'ScissorsSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Scissors',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Scissors',
}
,

{
  component: _Icons24X24StrokedScreamer,
  componentName: 'ScreamerSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Screamer',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Screamer',
}
,

{
  component: _Icons24X24StrokedScrewdriver,
  componentName: 'ScrewdriverSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Screwdriver',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Screwdriver',
}
,

{
  component: _Icons24X24StrokedShare,
  componentName: 'ShareSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Share',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Share',
}
,

{
  component: _Icons24X24StrokedShareAndroid,
  componentName: 'ShareAndroidSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ShareAndroid',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ShareAndroid',
}
,

{
  component: _Icons24X24StrokedShareiOs,
  componentName: 'ShareiOsSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ShareiOs',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ShareiOs',
}
,

{
  component: _Icons24X24StrokedSort2,
  componentName: 'Sort2SVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Sort2',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Sort2',
}
,

{
  component: _Icons24X24StrokedSortUp,
  componentName: 'SortUpSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/SortUp',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'SortUp',
}
,

{
  component: _Icons24X24StrokedSpeaker,
  componentName: 'SpeakerSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Speaker',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Speaker',
}
,

{
  component: _Icons24X24StrokedSpeakerOff,
  componentName: 'SpeakerOffSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/SpeakerOff',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'SpeakerOff',
}
,

{
  component: _Icons24X24StrokedSpeechBubble,
  componentName: 'SpeechBubbleSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/SpeechBubble',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'SpeechBubble',
}
,

{
  component: _Icons24X24StrokedSpruce,
  componentName: 'SpruceSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Spruce',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Spruce',
}
,

{
  component: _Icons24X24StrokedStatement,
  componentName: 'StatementSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Statement',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Statement',
}
,

{
  component: _Icons24X24StrokedSun,
  componentName: 'SunSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Sun',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Sun',
}
,

{
  component: _Icons24X24StrokedThermometer,
  componentName: 'ThermometerSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Thermometer',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Thermometer',
}
,

{
  component: _Icons24X24StrokedThumbsUp,
  componentName: 'ThumbsUpSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ThumbsUp',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ThumbsUp',
}
,

{
  component: _Icons24X24StrokedTooltip,
  componentName: 'TooltipSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Tooltip',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Tooltip',
}
,

{
  component: _Icons24X24StrokedTooltipPlus,
  componentName: 'TooltipPlusSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/TooltipPlus',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'TooltipPlus',
}
,

{
  component: _Icons24X24StrokedTouchId,
  componentName: 'TouchIdSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/TouchId',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'TouchId',
}
,

{
  component: _Icons24X24StrokedTrailer,
  componentName: 'TrailerSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Trailer',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Trailer',
}
,

{
  component: _Icons24X24StrokedTransfer,
  componentName: 'TransferSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Transfer',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Transfer',
}
,

{
  component: _Icons24X24StrokedTrash,
  componentName: 'TrashSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Trash',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Trash',
}
,

{
  component: _Icons24X24StrokedUnitedCustomers,
  componentName: 'UnitedCustomersSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/UnitedCustomers',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'UnitedCustomers',
}
,

{
  component: _Icons24X24StrokedUnknownType,
  componentName: 'UnknownTypeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/UnknownType',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'UnknownType',
}
,

{
  component: _Icons24X24StrokedUnlock,
  componentName: 'UnlockSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Unlock',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Unlock',
}
,

{
  component: _Icons24X24StrokedUpload,
  componentName: 'UploadSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Upload',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Upload',
}
,

{
  component: _Icons24X24StrokedViewCards,
  componentName: 'ViewCardsSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ViewCards',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ViewCards',
}
,

{
  component: _Icons24X24StrokedViewGrid,
  componentName: 'ViewGridSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ViewGrid',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ViewGrid',
}
,

{
  component: _Icons24X24StrokedViewLarge,
  componentName: 'ViewLargeSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ViewLarge',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ViewLarge',
}
,

{
  component: _Icons24X24StrokedViewList,
  componentName: 'ViewListSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ViewList',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ViewList',
}
,

{
  component: _Icons24X24StrokedViewQuick,
  componentName: 'ViewQuickSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/ViewQuick',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'ViewQuick',
}
,

{
  component: _Icons24X24StrokedWallet,
  componentName: 'WalletSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Wallet',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Wallet',
}
,

{
  component: _Icons24X24StrokedWatch,
  componentName: 'WatchSVG',
  importPath: '@sima-land/ui-quarks/icons/24x24/Stroked/Watch',
  packagePathname: 'icons/24x24/Stroked',
  packageFilename: 'Watch',
}
,

{
  component: _Icons32X32ColorfulLogo5Post,
  componentName: 'Logo5PostSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/Logo5Post',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'Logo5Post',
}
,

{
  component: _Icons32X32ColorfulLogoAptekaPlus,
  componentName: 'LogoAptekaPlusSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoAptekaPlus',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoAptekaPlus',
}
,

{
  component: _Icons32X32ColorfulLogoBoxberry,
  componentName: 'LogoBoxberrySVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoBoxberry',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoBoxberry',
}
,

{
  component: _Icons32X32ColorfulLogoDalli,
  componentName: 'LogoDalliSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoDalli',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoDalli',
}
,

{
  component: _Icons32X32ColorfulLogoDellin,
  componentName: 'LogoDellinSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoDellin',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoDellin',
}
,

{
  component: _Icons32X32ColorfulLogoDpd,
  componentName: 'LogoDpdSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoDpd',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoDpd',
}
,

{
  component: _Icons32X32ColorfulLogoGalamart,
  componentName: 'LogoGalamartSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoGalamart',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoGalamart',
}
,

{
  component: _Icons32X32ColorfulLogoOzon,
  componentName: 'LogoOzonSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoOzon',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoOzon',
}
,

{
  component: _Icons32X32ColorfulLogoPickPoint,
  componentName: 'LogoPickPointSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoPickPoint',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoPickPoint',
}
,

{
  component: _Icons32X32ColorfulLogoPost,
  componentName: 'LogoPostSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoPost',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoPost',
}
,

{
  component: _Icons32X32ColorfulLogoSberLogistic,
  componentName: 'LogoSberLogisticSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSberLogistic',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoSberLogistic',
}
,

{
  component: _Icons32X32ColorfulLogoSdek,
  componentName: 'LogoSdekSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSdek',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoSdek',
}
,

{
  component: _Icons32X32ColorfulLogoSima,
  componentName: 'LogoSimaSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSima',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoSima',
}
,

{
  component: _Icons32X32ColorfulLogoSimaBlue,
  componentName: 'LogoSimaBlueSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSimaBlue',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoSimaBlue',
}
,

{
  component: _Icons32X32ColorfulLogoSimaGreen,
  componentName: 'LogoSimaGreenSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSimaGreen',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoSimaGreen',
}
,

{
  component: _Icons32X32ColorfulLogoSimaPurple,
  componentName: 'LogoSimaPurpleSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoSimaPurple',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoSimaPurple',
}
,

{
  component: _Icons32X32ColorfulLogoYandex,
  componentName: 'LogoYandexSVG',
  importPath: '@sima-land/ui-quarks/icons/32x32/Colorful/LogoYandex',
  packagePathname: 'icons/32x32/Colorful',
  packageFilename: 'LogoYandex',
}
,

{
  component: _Icons40X40FilledPause,
  componentName: 'PauseSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Filled/Pause',
  packagePathname: 'icons/40x40/Filled',
  packageFilename: 'Pause',
}
,

{
  component: _Icons40X40FilledPlay,
  componentName: 'PlaySVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Filled/Play',
  packagePathname: 'icons/40x40/Filled',
  packageFilename: 'Play',
}
,

{
  component: _Icons40X40FilledViewing360,
  componentName: 'Viewing360SVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Filled/Viewing360',
  packagePathname: 'icons/40x40/Filled',
  packageFilename: 'Viewing360',
}
,

{
  component: _Icons40X40FilledViewing360Perspective,
  componentName: 'Viewing360PerspectiveSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Filled/Viewing360Perspective',
  packagePathname: 'icons/40x40/Filled',
  packageFilename: 'Viewing360Perspective',
}
,

{
  component: _Icons40X40StrokedBrand,
  componentName: 'BrandSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Brand',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Brand',
}
,

{
  component: _Icons40X40StrokedCamera,
  componentName: 'CameraSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Camera',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Camera',
}
,

{
  component: _Icons40X40StrokedCup,
  componentName: 'CupSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Cup',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Cup',
}
,

{
  component: _Icons40X40StrokedImageBroken,
  componentName: 'ImageBrokenSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/ImageBroken',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'ImageBroken',
}
,

{
  component: _Icons40X40StrokedLock,
  componentName: 'LockSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Lock',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Lock',
}
,

{
  component: _Icons40X40StrokedMap,
  componentName: 'MapSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Map',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Map',
}
,

{
  component: _Icons40X40StrokedMatryoshka,
  componentName: 'MatryoshkaSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Matryoshka',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Matryoshka',
}
,

{
  component: _Icons40X40StrokedPaymentCards,
  componentName: 'PaymentCardsSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/PaymentCards',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'PaymentCards',
}
,

{
  component: _Icons40X40StrokedPaymentCash,
  componentName: 'PaymentCashSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/PaymentCash',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'PaymentCash',
}
,

{
  component: _Icons40X40StrokedPaymentCheck,
  componentName: 'PaymentCheckSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/PaymentCheck',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'PaymentCheck',
}
,

{
  component: _Icons40X40StrokedPaymentMoney,
  componentName: 'PaymentMoneySVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/PaymentMoney',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'PaymentMoney',
}
,

{
  component: _Icons40X40StrokedPeople,
  componentName: 'PeopleSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/People',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'People',
}
,

{
  component: _Icons40X40StrokedPlanet,
  componentName: 'PlanetSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Planet',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Planet',
}
,

{
  component: _Icons40X40StrokedPlayRound,
  componentName: 'PlayRoundSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/PlayRound',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'PlayRound',
}
,

{
  component: _Icons40X40StrokedProducts,
  componentName: 'ProductsSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Products',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Products',
}
,

{
  component: _Icons40X40StrokedPurchases,
  componentName: 'PurchasesSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Purchases',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Purchases',
}
,

{
  component: _Icons40X40StrokedSad,
  componentName: 'SadSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Sad',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Sad',
}
,

{
  component: _Icons40X40StrokedSquares,
  componentName: 'SquaresSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Squares',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Squares',
}
,

{
  component: _Icons40X40StrokedTimer,
  componentName: 'TimerSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/Timer',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'Timer',
}
,

{
  component: _Icons40X40StrokedTooltipLike,
  componentName: 'TooltipLikeSVG',
  importPath: '@sima-land/ui-quarks/icons/40x40/Stroked/TooltipLike',
  packagePathname: 'icons/40x40/Stroked',
  packageFilename: 'TooltipLike',
}
,

{
  component: _Icons64X64ColorfulTouchScrollX,
  componentName: 'TouchScrollXSVG',
  importPath: '@sima-land/ui-quarks/icons/64x64/Colorful/TouchScrollX',
  packagePathname: 'icons/64x64/Colorful',
  packageFilename: 'TouchScrollX',
}
,

{
  component: _Icons64X64StrokedEighteenPlus,
  componentName: 'EighteenPlusSVG',
  importPath: '@sima-land/ui-quarks/icons/64x64/Stroked/EighteenPlus',
  packagePathname: 'icons/64x64/Stroked',
  packageFilename: 'EighteenPlus',
}
,

{
  component: _Icons64X64StrokedUpload,
  componentName: 'UploadSVG',
  importPath: '@sima-land/ui-quarks/icons/64x64/Stroked/Upload',
  packagePathname: 'icons/64x64/Stroked',
  packageFilename: 'Upload',
}

];
